import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Warehouse } from 'src/app/assabil-kernel/models/entities/master-data/warehouse-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PackingOrder } from './packing-order';

export class Pack extends BaseEntity {
	
  	id              	 : number;
	packCode			 : string;
	packingOrder  		 : PackingOrder ;
	warehouse			 : Warehouse;
	branch				 : Branch;
	hold				 : boolean;
	holdReason			 : String;
	packingOrderStepRank : number;

  constructor() {
    super();

  }
}

	
